module.exports = __webpack_public_path__ + "img/symbol_6.c50dff1b.png";